import React from 'react'

import { useSaveMinicrud } from './_requests/saveMinicrud'
import LazySelect from '../../../components/form/LazySelect'
import MinicrudsLoader, { useMinicruds } from '../_load/MinicrudsLoader'

const MinicrudsSelect = ({ entity, onChange, ...props }) => {
  const onSuccess = result => onChange(result.id, result.name, { origin: result, value: result.id, label: result.name })
  const [onCreate, { loading }] = useSaveMinicrud(entity, onSuccess)

  return (
    <LazySelect
      Loader={MinicrudsLoader}
      loaderProps={{ entities: entity }}
      dataHook={useMinicruds}
      onCreate={onCreate}
      loading={loading}
      onChange={onChange}
      {...props}
    />
  )
}

export default MinicrudsSelect
